import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { Button, Message, Modal } from "semantic-ui-react";
import CustomLoader from "../common/CustomLoader";

class DeleteAccountModal extends React.PureComponent {
  static propTypes = {
    /** Modal state. True == open .*/
    openModal: PropTypes.bool,
    /** Function to run on modal close. */
    onModalClose: PropTypes.func,
    /** Function to call when submitting form. */
    onSubmit: PropTypes.func,
    /** Reflects onSubmit form error state. This works nice with fathers' Redux state management. */
    formSubmitFailed: PropTypes.bool,
    /** Message to show on onSubmit error. */
    formSubmitFailedMessage: PropTypes.string,
    /** Is this user the owner of the account? */
    isUserOwnerOfAccount: PropTypes.bool
  };

  _onClose = () => this.props.onModalClose();

  render() {
    if (this.props.submittingForm) {
      return <CustomLoader />;
    }
    return (
      <Modal dimmer="blurring" size="tiny" open={this.props.openModal} onClose={this._onClose}>
        <Modal.Header>Delete account</Modal.Header>
        <Modal.Content>
          <p>Are you sure you want to delete your account?</p>
          {this.props.isUserOwnerOfAccount ? (
            <p>This will include your user, account and all users related to your account.</p>
          ) : null}
        </Modal.Content>
        <Modal.Actions style={{ textAlign: "center" }}>
          <Button.Group>
            <Button onClick={this._onClose}>Cancel</Button>
            <Button.Or />
            <Button negative onClick={() => this.props.onSubmit()}>
              Confirm
            </Button>
          </Button.Group>
        </Modal.Actions>
        {this.props.formSubmitFailed ? (
          <Message negative>{this.props.formSubmitFailedMessage}</Message>
        ) : null}
      </Modal>
    );
  }
}

const DeleteAccountFormModal = reduxForm({
  form: "deleteAccount"
})(DeleteAccountModal);

export default connect()(DeleteAccountFormModal);
